import { DmiPagesComponent } from './dmi-pages.component';
import { NgModule } from '@angular/core';

import { CommonModule, APP_BASE_HREF } from '@angular/common';
import { Router, Routes, RouterModule, UrlSegment } from '@angular/router';
import { UiElementsModule } from 'src/app/common-modules/ui-elements.module';
import { MappingModule } from 'src/app/common-modules/mapping.module';
import { DmiCommonModule } from 'src/app/common-modules/dmi-common.module';
import { ArcgisConfigComponent } from './data/arcgis/arcgis-config/arcgis-config.component';
import { WmsConfigComponent } from './data/wms/wms-config/wms-config.component';
import { MapsComponent } from './maps/maps.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { DMIGuard } from 'src/app/auth/dmi.guard';
export function testArcgisMatcher(url: UrlSegment[]) {
  if (url.length >= 3 && url[0].path === 'test' && url[1].path === 'arcgis' && url[2].path === 'config') {
    return { consumed: url };
  }
  return null;
}
export function arcgisMatcher(url: UrlSegment[]) {
  if (url.length >= 3 && url[0].path === 'data' && url[1].path === 'arcgis' && url[2].path === 'config') {
    return { consumed: url };
  }
  return null;
}
const routes: Routes = [
	{
		path: '',
    component:DmiPagesComponent,
		children: [
      {
        matcher:arcgisMatcher,
        component: ArcgisConfigComponent,
        canActivate: ((window.location.href.indexOf('/dmi/')>-1) || (window.location.href.indexOf('/dmi-pages/') > -1)) ? [DMIGuard] : [AuthGuard]
      },{
        matcher:testArcgisMatcher,
        component: ArcgisConfigComponent,
        canActivate: [AuthGuard]
      },{
        path: 'data/wms/config',
        component: WmsConfigComponent
      }
		]
	}

];


@NgModule({
	declarations: [
    DmiPagesComponent,
    MapsComponent
	],
	imports: [
		CommonModule,
		DmiCommonModule,
		RouterModule.forChild(routes),
		UiElementsModule,
		MappingModule

	],
	exports: [
    DmiPagesComponent

	],
	providers: [
		// tslint:disable-next-line: no-string-literal
		{
			provide: APP_BASE_HREF,
			// tslint:disable-next-line: no-string-literal
			useValue: window['_app_base'] || window['base_href']
		}

	]
})
export class DmiPagesModule { }
